// extracted by mini-css-extract-plugin
export default {"pagination":"PaginatioonBase_pagination__WzNrW","pagination_active":"PaginatioonBase_pagination_active__FtKq7","pagination_number":"PaginatioonBase_pagination_number__+wdz5"};